import {EditOutlined, HomeOutlined, PlusOutlined, UserOutlined} from '@ant-design/icons';
import {Breadcrumb, Button, Table} from 'antd';
import {useState} from 'react';
import {useSelector} from 'react-redux';

import {RqGetDeliveryCharges} from '../../../reactQuery/apis';
import {selectAuth} from '../../../redux/selectors';

import {DeliveryChargesModal} from './DeliveryChargesModal';

const DeliveryChargesScreen = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [updateRecord, setUpdateRecord] = useState(null);

  const auth = useSelector(selectAuth);

  const token =auth?.tokenData;

  const {data: deliveryData, isLoading, refetch} = RqGetDeliveryCharges(token);

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'srno',
      key: 'srno',
      width: 80,
    },
    {
      title: 'State',
      dataIndex: 'state',
      key: 'state',
      width: 200,
    },
    {
      title: 'Delivery Days',
      dataIndex: 'deliveryDays',
      key: 'deliveryDays',
      width: 150,
    },
    {
      title: 'Charges',
      dataIndex: 'charges',
      key: 'charges',
      width: 120,
    },

    {
      title: 'Action',
      key: 'action',
      width: 80,
      render: (_, record) => (
        <div className={'flex gap-3'}>
          <EditOutlined
            onClick={() => {
              setUpdateRecord(record);
              setIsModalVisible(true);
            }}
            className={'text-black cursor-pointer'}
          />
        </div>
      ),
    },
  ];

  const formattedData = deliveryData?.map((item, idx) => ({
    key: item.id,
    id: item.id,
    srno: idx + 1,
    state: item.state,
    charges: item.charges,
    deliveryDays: item.deliveryDays,
  }));

  return (
    <div>
      <Breadcrumb
        className={'lg:block hidden'}
        items={[
          {href: '/', title: <span><HomeOutlined /></span>},
          {title: <span><UserOutlined />Delivery Charges</span>},
        ]}
      />

      <div className={'flex justify-between items-center mt-3'}>
        <h1 className={'font-bold text-lg text-primary-800'}>Delivery Charges List</h1>

        <Button type={'primary'} onClick={() => setIsModalVisible(true)}>
          <PlusOutlined /> Add Delivery Charge
        </Button>
      </div>

      <div className={'mt-4'}>
        <Table
          loading={isLoading}
          columns={columns}
          dataSource={formattedData}
          scroll={{x: 'max-content'}}
          pagination={{
            pageSizeOptions: ['10', '20', '50'],
            showSizeChanger: true,
          }}
        />
      </div>

      <DeliveryChargesModal
        open={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          setUpdateRecord(null);
        }}
        refetch={refetch}
        updateRecord={updateRecord}
      />
    </div>
  );
};

export default DeliveryChargesScreen;
